"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDesign = isDesign;
exports.isDesignGroup = isDesignGroup;
const typeguard_1 = require("../types/typeguard");
const typeguard_2 = require("../types/typeguard");
const designRuleSet = {
  id: typeguard_2.isNonEmptyString,
  pretty_name: typeguard_2.isNonEmptyString,
  layers: val => Array.isArray(val) && val.every(typeguard_2.isNonEmptyString),
  designId: (0, typeguard_2.optional)(typeguard_2.isNonEmptyString),
  default: (0, typeguard_2.optional)(typeguard_2.isBool),
  sizeId: (0, typeguard_2.optional)(typeguard_2.isNonEmptyString),
  coverage: (0, typeguard_2.optional)(typeguard_2.isNonEmptyString),
  allowedPages: (0, typeguard_2.optional)(typeguard_2.isNonEmptyString),
  allowedPageCounts: (0, typeguard_2.optional)(typeguard_2.isNonEmptyString),
  isCompositeDesign: (0, typeguard_2.optional)(typeguard_2.isBool),
  tags: (0, typeguard_2.optional)(val => (0, typeguard_1.isArrayOrString)(val)),
  order: (0, typeguard_2.optional)(val => Array.isArray(val)),
  isAutofillable: (0, typeguard_2.optional)(typeguard_2.isBool),
  allowedPrintableGroupTypes: (0, typeguard_2.optional)(val => Array.isArray(val) && val.every(typeguard_2.isNonEmptyString))
};
function isDesign(d) {
  return (0, typeguard_2.isType)(d, designRuleSet);
}
function isDesignGroup(dg) {
  return dg && dg.id && typeof dg.id === 'string' && dg.default && typeof dg.default === 'string' && dg.designs && Array.isArray(dg.designs) && dg.designs.reduce((acc, curr) => acc && typeof curr === 'string', true);
}